import React from "react";
import {
  Grid,
  Box,
  Container,
  Typography,
  List,
  ListItem,
  makeStyles,
  Divider,
  IconButton,
  Link,
} from "@material-ui/core";
import { Link as RouterLink, useHistory } from "react-router-dom";
import { AiOutlineMail } from "react-icons/ai";
import { toast } from "react-toastify";
import { RiInstagramLine } from "react-icons/ri";
import Scroll from "react-scroll";
import { FaTelegram } from "react-icons/fa";

const ScrollLink = Scroll.Link;

const useStyles = makeStyles((theme) => ({
  baseSection: {
    display: "flex",
    justifyContent: "space-between",
    "& p": {
      color: theme.palette.text.textfooter,
      fontSize: "16px",
    },
    "& a": {
      textDecoration: "none",
      color: theme.palette.text.dull,
    },
    "@media(max-width:565px)": {
      display: "flex",
      flexDirection: "column",
    },
  },
  privacy: {
    display: "flex",
    "@media(max-width:565px)": {
      marginTop: "1.5rem",
    },
  },
  subpart: {
    "& .footerimgBox": {
      position: "absolute",
      maxWidth: "330px",
      width: "auto",
      right: "50px",
      bottom: "10%",
      zIndex: "-1",
    },
    background: "#23242f",
    position: "relative",
    zIndex: 1,
    padding: "60px 0px 40px",
    overflow: "hidden",
    "& h5": {
      color: "rgba(255, 255, 255, 0.6)",
      width: "100%",
      maxWidth: "252px",
      marginBottom: "12px",
      fontWeight: "300",
      [theme.breakpoints.down("sm")]: {
        fontSize: "14px",
        width: "100%",
        maxWidth: "100%",
        marginBottom: "10px",
      },
    },
    "@media(max-width:599px)": {
      padding: "20px 10px 24px 10px",
    },
    "& h2": {
      fontSize: "35px",
      fontWeight: "500",
      lineHeight: "46px",
      marginBottom: "20px",
      [theme.breakpoints.down("sm")]: {
        fontSize: "26px",
        lineHeight: "31px",
      },
      [theme.breakpoints.down("xs")]: {
        fontSize: "18px",
        marginBottom: "0px",
      },
    },
    "& p": {
      color: "rgba(255, 255, 255, 0.6)",
    },
    "& h4": {
      fontSize: "20px",
      fontWeight: "400",
    },
  },

  listbox: {
    background: "none",
    border: "none",
    margin: "0px",
    "& a": {
      color: "rgba(255, 255, 255, 0.6)",
      display: "block",
      fontSize: "14px",
      fontWeight: "300",
      paddingTop: "4px",
      fontFamily: "'Sora', sans-serif",
      [theme.breakpoints.down("sm")]: {
        fontSize: "14px",
      },
      "&:hover": {
        color: "none",
      },
    },
  },
  contactbox: {
    display: "flex",
    alignItems: "center",
    marginBottom: "-10px",
    marginLeft: "-10px",
    marginTop: "4px",
    "& a": {
      color: "rgba(255, 255, 255, 0.6)",
      fontFamily: "'Sora', sans-serif",
      fontSize: "14px",
      fontWeight: "300",
      textDecoration: "none",
      [theme.breakpoints.down("sm")]: {
        fontSize: "12px",
      },
    },
    "& svg": {
      color: "#3F3E41",
      fontSize: "18px",
    },
  },

  buttonbox: {
    marginTop: "10px",
    "& button": {
      fontSize: "16px",
      fontWeight: "300",
      color: "#fff",
    },
  },
  subfooter: {
    paddingTop: "40px",
    paddingBottom: "32px",
    [theme.breakpoints.down("xs")]: {
      paddingBottom: "16px",
    },
  },
  leftbox: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    maxWidth: "130px",
    marginTop: "30px",
    "& .dot": {
      height: "40px",
      width: "40px",
      borderRadius: "50%",
      backgroundColor: "rgba(255, 255, 255, 0.04)",
      cursor: "pointer",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginRight: "6px",
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: "16px",
    },
  },
  icon: {
    margin: "0px 4px",
    color: "rgba(255, 255, 255, 0.15)",
    cursor: "pointer",
    width: "20px",
    "&:hover": {
      color: "#a28fe0",
    },
  },
}));

export default function Liquidity() {
  const classes = useStyles();
  const history = useHistory();
  const tokenCheck = window.sessionStorage.getItem("token");
  const currentYear = new Date().getFullYear();
  return (
    <>
      <Box className={classes.subpart}>
        <div className="footerleft"></div>
        <img
          onDragStart={(e) => e.preventDefault()}
          onContextMenu={(e) => e.preventDefault()}
          className="footerimgBox"
          // src="images/footerimg.png"
          alt=""
        />
        <Box>
          <Container>
            <Box>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={4} lg={4}>
                  <Box>
                    <img
                      onDragStart={(e) => e.preventDefault()}
                      onContextMenu={(e) => e.preventDefault()}
                      src="/images/logo_1.png"
                      alt=""
                      width="100%"
                      style={{ maxWidth: "179px", margin: "0 auto" }}
                      // style={{ maxWidth: "192px", margin: "0 auto" }}
                    />
                  </Box>{" "}
                  <Box mt={1} mb={1}>
                    <Typography variant="body2" style={{ maxWidth: "390px" }}>
                      ICO Space is an Ethereum Virtual Machine (EVM) compatible
                      blockchain constructed using a dependable and safe
                      Proof-of-Authority (PoA) consensus algorithm. The ICO
                      Space blockchain ecosystem delivers unparalleled speed and
                      minimal transaction fees while ensuring the highest level
                      of security and scalability.
                    </Typography>{" "}
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={8} lg={8}>
                  <Grid container spacing={2}>
                    <Grid item xs={6} sm={4} md={4} lg={4}>
                      <Typography variant="h4">Web Link</Typography>
                      <List className={classes.listbox}>
                        <ScrollLink
                          className="hovertext"
                          // to="/"
                          onClick={() => history.push("/?id=roadmap")}
                          smooth={true}
                          duration={500}
                          to="roadmap"
                          style={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          <ListItem>Roadmap</ListItem>
                        </ScrollLink>

                        <ScrollLink
                          className="hovertext"
                          smooth={true}
                          duration={500}
                          to="tokenoimics"
                          onClick={() => history.push("/?id=tokenoimics")}
                          style={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          <ListItem>Tokenomics</ListItem>
                        </ScrollLink>
                        <RouterLink
                          className="hovertext"
                          to="/risk-disclouser"
                          style={{ textDecoration: "none" }}
                        >
                          <ListItem>Risk Disclosure</ListItem>
                        </RouterLink>

                        <RouterLink
                          className="hovertext"
                          to="/aml-policy"
                          style={{ textDecoration: "none" }}
                        >
                          <ListItem>AML Policy</ListItem>
                        </RouterLink>

                        <a
                          target="_blank"
                          // href="images/Fieres_Whitepaper.pdf"
                          style={{
                            cursor: "pointer",
                            marginTop: "6px",
                            textDecoration: "none",
                          }}
                        >
                          White Paper
                        </a>
                      </List>{" "}
                    </Grid>
                    <Grid item xs={6} sm={4} md={4} lg={4}>
                      <Typography variant="h4">Faqs</Typography>
                      <List className={classes.listbox}>
                        <RouterLink
                          className="hovertext"
                          to="/contactus"
                          style={{ textDecoration: "none" }}
                        >
                          <ListItem>Contact Us</ListItem>
                        </RouterLink>

                        <RouterLink
                          className="hovertext"
                          to="/about-us"
                          style={{ textDecoration: "none" }}
                        >
                          <ListItem>About Us</ListItem>
                        </RouterLink>
                        <RouterLink
                          // className="hovertext"
                          // target="_blank"
                          // to="images/Terms_and_Conditions_2.01-0223.pdf" //here changes made in link
                          style={{ textDecoration: "none" }}
                        >
                          <ListItem>Terms & Conditions</ListItem>
                        </RouterLink>
                        <RouterLink
                          className="hovertext"
                          style={{ textDecoration: "none" }}
                          onClick={() => {
                            if (tokenCheck) {
                              history.push("/edit-profile");
                            } else {
                              toast.warn("Please login first.");
                            }
                          }}
                        >
                          <ListItem>Profile</ListItem>
                        </RouterLink>
                      </List>{" "}
                    </Grid>

                    <Grid item xs={6} sm={3} md={3} lg={3}>
                      <Typography variant="h4">Contact Us</Typography>
                      <Box
                        className={classes.contactbox}
                        style={{ cursor: "pointer" }}
                      >
                        <IconButton>
                          <AiOutlineMail />
                        </IconButton>
                        <Link href="mailto:icosupport@fieres.io">
                          icosupport@icospace.io
                        </Link>
                      </Box>
                      <Box className={classes.leftbox}>
                        <Link
                          target="_blank"
                          // href="https://t.me/+YEuUrv0Hw0s0NmE0" //here url hided
                        >
                          <Box className="dot">
                            <FaTelegram className={classes.icon} />
                          </Box>
                        </Link>
                        <Link
                          target="_blank"
                          href="https://telegram.org/tour/groups" //here url hided
                        >
                          <Box className="dot">
                            <RiInstagramLine className={classes.icon} />
                          </Box>
                        </Link>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Container>
          <Box className={classes.subfooter}>
            <Divider style={{ backgroundColor: "rgb(255 255 255 / 10%)" }} />
          </Box>
          <Container>
            <Box className={classes.baseSection}>
              <Box className={classes.privacy}>
                <Link
                  // href="images/privacy-policy.pdf"
                  target="_blank"
                  style={{ textDecoration: "none" }}
                >
                  Privacy Policy
                </Link>
                &nbsp;
              </Box>
              <Typography variant="body1">
                Copyright©{currentYear}. Created with love by ICO Space
              </Typography>
            </Box>
          </Container>
        </Box>
      </Box>
    </>
  );
}
